import {
	UserTypes,
	getAgencyId,
	getApplicationHeaders,
	getUserId,
	httpClient,
} from "@utils";

export class PushNotificationsTokenApiService {
	static get baseUrl(): string {
		return `${WEBPACK_BASE_ADDRESS}platform/mobile-push-user-tokens`;
	}

	static getRequestHeaders = (
		activeAccount: UserTypes = UserTypes.PRIMARY
	) => {
		const appHeaders = getApplicationHeaders(activeAccount);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async updateUserPushNotificationToken(
		oldToken: string,
		newToken: string,
		timestamp: string,
		userType: UserTypes = UserTypes.PRIMARY
	) {
		return httpClient.put(
			`${this.baseUrl}/token`,
			JSON.stringify({
				oldToken,
				newToken,
				timestamp,
			}),
			this.getRequestHeaders(userType)
		);
	}

	static async setUserPushNotificationToken(
		pushToken: string,
		userType: UserTypes = UserTypes.PRIMARY
	) {
		return httpClient.post(
			`${this.baseUrl}/user-token-post`,
			JSON.stringify({
				token: pushToken,
				userId: getUserId(userType),
				agencyId: getAgencyId(userType),
			}),
			this.getRequestHeaders(userType),
			{ responseType: "json" }
		);
	}
}
